/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAggregate1 } from './UserAggregate1';
import {
    UserAggregate1FromJSON,
    UserAggregate1FromJSONTyped,
    UserAggregate1ToJSON,
    UserAggregate1ToJSONTyped,
} from './UserAggregate1';

/**
 * 
 * @export
 * @interface GetUsersByOrganizationResponse
 */
export interface GetUsersByOrganizationResponse {
    /**
     * 
     * @type {Array<UserAggregate1>}
     * @memberof GetUsersByOrganizationResponse
     */
    data: Array<UserAggregate1>;
}

/**
 * Check if a given object implements the GetUsersByOrganizationResponse interface.
 */
export function instanceOfGetUsersByOrganizationResponse(value: object): value is GetUsersByOrganizationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetUsersByOrganizationResponseFromJSON(json: any): GetUsersByOrganizationResponse {
    return GetUsersByOrganizationResponseFromJSONTyped(json, false);
}

export function GetUsersByOrganizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersByOrganizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(UserAggregate1FromJSON)),
    };
}

export function GetUsersByOrganizationResponseToJSON(json: any): GetUsersByOrganizationResponse {
    return GetUsersByOrganizationResponseToJSONTyped(json, false);
}

export function GetUsersByOrganizationResponseToJSONTyped(value?: GetUsersByOrganizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(UserAggregate1ToJSON)),
    };
}

